AFRAME.registerComponent('add-unit-vr-popup', {
    init: function() {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');
        
        this.selectedTicker = null;
        this.selectedCompany = null;
        this.options = {};

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setOptions: function(options) {
        this.options = options || {};
    },

    open: function() {
        this.render();
    },

    close: function() {
        const searchInput = document.querySelector('#vr-watchlist-search-input');
        if (searchInput) {
            searchInput.value = '';
            const searchTextDisplay = this.el.querySelector('#vr-search-text-display');
            if (searchTextDisplay) searchTextDisplay.setAttribute('value', '');
            const searchPlaceholder = this.el.querySelector('#vr-search-placeholder');
            if (searchPlaceholder) searchPlaceholder.setAttribute('visible', true);
        }
        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        if (qtyInput) {
            qtyInput.value = '';
            const qtyTextDisplay = this.el.querySelector('#vr-qty-text-display');
            if (qtyTextDisplay) qtyTextDisplay.setAttribute('value', '');
        }
        const priceInput = document.querySelector('#vr-watchlist-price-input');
        if (priceInput) {
            priceInput.value = '';
            const priceTextDisplay = this.el.querySelector('#vr-price-text-display');
            if (priceTextDisplay) priceTextDisplay.setAttribute('value', '');
        }
        const statusText = this.el.querySelector('#vr-add-unit-status');
        if (statusText) statusText.setAttribute('value', '');
    },

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // Background
        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.8);
        bg.setAttribute('height', 0.8);
        bg.setAttribute('position', '-0.4 -0.4 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        // Header
        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Add to Watchlist');
        title.setAttribute('font-size', 0.05);
        title.setAttribute('color', txtColor);
        title.setAttribute('position', '0 0.32 0.01');
        title.setAttribute('anchor', 'center');
        this.el.appendChild(title);

        // Close (X)
        const closeGroup = document.createElement('a-entity');
        closeGroup.setAttribute('position', '0.36 0.36 0.01');
        this.el.appendChild(closeGroup);

        const closeText = document.createElement('a-troika-text');
        closeText.setAttribute('value', '×');
        closeText.setAttribute('font-size', 0.06);
        closeText.setAttribute('color', txtColor);
        closeText.setAttribute('anchor', 'center');
        closeText.setAttribute('position', '0 0 0');
        closeGroup.appendChild(closeText);

        const closeHitbox = document.createElement('a-plane');
        closeHitbox.setAttribute('width', 0.08);
        closeHitbox.setAttribute('height', 0.08);
        closeHitbox.setAttribute('opacity', 0);
        closeHitbox.setAttribute('data-raycastable', '');
        closeHitbox.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('add-unit-vr-popup'));
        closeGroup.appendChild(closeHitbox);

        // Content Area
        const content = document.createElement('a-entity');
        content.setAttribute('position', '0 0.05 0.01');
        this.el.appendChild(content);

        // --- Search Field ---
        const searchGroup = document.createElement('a-entity');
        searchGroup.setAttribute('position', '0 0.18 0');
        content.appendChild(searchGroup);

        const searchFocusBorder = document.createElement('a-rounded-box');
        searchFocusBorder.setAttribute('width', 0.72);
        searchFocusBorder.setAttribute('height', 0.10);
        searchFocusBorder.setAttribute('depth', 0.004);
        searchFocusBorder.setAttribute('color', '#3636E3');
        searchFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        searchFocusBorder.setAttribute('radius', 0.012);
        searchFocusBorder.setAttribute('visible', false);
        searchGroup.appendChild(searchFocusBorder);
        this._searchFocusBorder = searchFocusBorder;

        const searchBox = document.createElement('a-rounded-box');
        searchBox.setAttribute('width', 0.7);
        searchBox.setAttribute('height', 0.08);
        searchBox.setAttribute('depth', 0.005);
        searchBox.setAttribute('color', isLight ? '#DDD' : '#333');
        searchBox.setAttribute('position', '0 -0.04 0');
        searchBox.setAttribute('radius', 0.01);
        searchBox.setAttribute('data-raycastable', '');
        searchGroup.appendChild(searchBox);

        // Text
        const searchText = document.createElement('a-troika-text');
        searchText.setAttribute('id', 'vr-search-text-display');
        searchText.setAttribute('value', '');
        searchText.setAttribute('font-size', 0.035);
        searchText.setAttribute('color', txtColor);
        searchText.setAttribute('position', '0 -0.04 0.01');
        searchText.setAttribute('anchor', 'center');
        searchGroup.appendChild(searchText);

        const searchPlaceholder = document.createElement('a-troika-text');
        searchPlaceholder.setAttribute('id', 'vr-search-placeholder');
        searchPlaceholder.setAttribute('value', 'Search tickers or company...');
        searchPlaceholder.setAttribute('font-size', 0.03);
        searchPlaceholder.setAttribute('color', '#666');
        searchPlaceholder.setAttribute('position', '0 -0.04 0.01');
        searchPlaceholder.setAttribute('anchor', 'center');
        searchGroup.appendChild(searchPlaceholder);

        // Hidden hitbox for clicks (maps to hidden input)
        const searchHitbox = document.createElement('a-entity');
        searchHitbox.setAttribute('position', '0 -0.04 0.012');
        searchHitbox.setAttribute('geometry', 'primitive: plane; width: 0.7; height: 0.08');
        searchHitbox.setAttribute('html', 'html:#vr-watchlist-search-input; cursor:#cursor');
        searchHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        searchHitbox.setAttribute('data-raycastable', '');
        searchGroup.appendChild(searchHitbox);

        // Suggestions container
        const suggestions = document.createElement('a-entity');
        suggestions.setAttribute('id', 'vr-watchlist-suggestions');
        suggestions.setAttribute('position', '0 -0.08 0.01');
        suggestions.setAttribute('visible', false);
        searchGroup.appendChild(suggestions);

        // --- Qty and Price row ---
        const inputsRow = document.createElement('a-entity');
        inputsRow.setAttribute('position', '0 -0.05 0');
        content.appendChild(inputsRow);

        // Qty
        const qtyGroup = document.createElement('a-entity');
        qtyGroup.setAttribute('position', '-0.18 0 0');
        inputsRow.appendChild(qtyGroup);

        const qtyLabel = document.createElement('a-troika-text');
        qtyLabel.setAttribute('value', '# of Shares');
        qtyLabel.setAttribute('font-size', 0.025);
        qtyLabel.setAttribute('color', '#888');
        qtyLabel.setAttribute('position', '0 0.06 0');
        qtyLabel.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyLabel);

        const qtyFocusBorder = document.createElement('a-rounded-box');
        qtyFocusBorder.setAttribute('width', 0.36);
        qtyFocusBorder.setAttribute('height', 0.10);
        qtyFocusBorder.setAttribute('depth', 0.004);
        qtyFocusBorder.setAttribute('color', '#3636E3');
        qtyFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        qtyFocusBorder.setAttribute('radius', 0.012);
        qtyFocusBorder.setAttribute('visible', false);
        qtyGroup.appendChild(qtyFocusBorder);
        this._qtyFocusBorder = qtyFocusBorder;

        const qtyBox = document.createElement('a-rounded-box');
        qtyBox.setAttribute('width', 0.34);
        qtyBox.setAttribute('height', 0.08);
        qtyBox.setAttribute('depth', 0.005);
        qtyBox.setAttribute('color', isLight ? '#DDD' : '#333');
        qtyBox.setAttribute('position', '0 -0.04 0');
        qtyBox.setAttribute('radius', 0.01);
        qtyBox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyBox);

        const qtyText = document.createElement('a-troika-text');
        qtyText.setAttribute('id', 'vr-qty-text-display');
        qtyText.setAttribute('value', '');
        qtyText.setAttribute('font-size', 0.035);
        qtyText.setAttribute('color', txtColor);
        qtyText.setAttribute('position', '0 -0.04 0.01');
        qtyText.setAttribute('anchor', 'center');
        qtyGroup.appendChild(qtyText);

        const qtyHitbox = document.createElement('a-entity');
        qtyHitbox.setAttribute('position', '0 -0.04 0.012');
        qtyHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        qtyHitbox.setAttribute('html', 'html:#vr-watchlist-qty-input; cursor:#cursor');
        qtyHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        qtyHitbox.setAttribute('data-raycastable', '');
        qtyGroup.appendChild(qtyHitbox);

        // Price
        const priceGroup = document.createElement('a-entity');
        priceGroup.setAttribute('position', '0.18 0 0');
        inputsRow.appendChild(priceGroup);

        const priceLabel = document.createElement('a-troika-text');
        priceLabel.setAttribute('value', 'Cost Basis (total cost)');
        priceLabel.setAttribute('font-size', 0.025);
        priceLabel.setAttribute('color', '#888');
        priceLabel.setAttribute('position', '0 0.06 0');
        priceLabel.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceLabel);

        const priceFocusBorder = document.createElement('a-rounded-box');
        priceFocusBorder.setAttribute('width', 0.36);
        priceFocusBorder.setAttribute('height', 0.10);
        priceFocusBorder.setAttribute('depth', 0.004);
        priceFocusBorder.setAttribute('color', '#3636E3');
        priceFocusBorder.setAttribute('position', '0 -0.04 -0.001');
        priceFocusBorder.setAttribute('radius', 0.012);
        priceFocusBorder.setAttribute('visible', false);
        priceGroup.appendChild(priceFocusBorder);
        this._priceFocusBorder = priceFocusBorder;

        const priceBox = document.createElement('a-rounded-box');
        priceBox.setAttribute('width', 0.34);
        priceBox.setAttribute('height', 0.08);
        priceBox.setAttribute('depth', 0.005);
        priceBox.setAttribute('color', isLight ? '#DDD' : '#333');
        priceBox.setAttribute('position', '0 -0.04 0');
        priceBox.setAttribute('radius', 0.01);
        priceBox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceBox);

        const priceText = document.createElement('a-troika-text');
        priceText.setAttribute('id', 'vr-price-text-display');
        priceText.setAttribute('value', '');
        priceText.setAttribute('font-size', 0.035);
        priceText.setAttribute('color', txtColor);
        priceText.setAttribute('position', '0 -0.04 0.01');
        priceText.setAttribute('anchor', 'center');
        priceGroup.appendChild(priceText);

        const priceHitbox = document.createElement('a-entity');
        priceHitbox.setAttribute('position', '0 -0.04 0.012');
        priceHitbox.setAttribute('geometry', 'primitive: plane; width: 0.34; height: 0.08');
        priceHitbox.setAttribute('html', 'html:#vr-watchlist-price-input; cursor:#cursor');
        priceHitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        priceHitbox.setAttribute('data-raycastable', '');
        priceGroup.appendChild(priceHitbox);

        // Status / Selection display
        const statusText = document.createElement('a-troika-text');
        statusText.setAttribute('id', 'vr-add-unit-status');
        statusText.setAttribute('value', '');
        statusText.setAttribute('font-size', 0.025);
        statusText.setAttribute('color', '#AAA');
        statusText.setAttribute('position', '0 -0.18 0');
        statusText.setAttribute('anchor', 'center');
        content.appendChild(statusText);

        // Buttons
        const buttons = document.createElement('a-entity');
        buttons.setAttribute('position', '0 -0.3 0.02');
        content.appendChild(buttons);

        const cancelBtn = document.createElement('a-entity');
        cancelBtn.setAttribute('position', '-0.15 0 0');
        cancelBtn.setAttribute('ui-button', {
            label: 'Cancel',
            width: 0.18,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        cancelBtn.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('add-unit-vr-popup'));
        buttons.appendChild(cancelBtn);

        const addBtn = document.createElement('a-entity');
        addBtn.setAttribute('id', 'vr-confirm-add-btn');
        addBtn.setAttribute('position', '0.15 0 0');
        addBtn.setAttribute('ui-button', {
            label: 'Add',
            width: 0.18,
            height: 0.07,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        addBtn.addEventListener('click', () => this.handleConfirm());
        buttons.appendChild(addBtn);

        this.setupSearchLogic();
    },

    setupSearchLogic: function() {
        const searchInput = document.querySelector('#vr-watchlist-search-input');
        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        const priceInput = document.querySelector('#vr-watchlist-price-input');

        const searchTextDisplay = this.el.querySelector('#vr-search-text-display');
        const searchPlaceholder = this.el.querySelector('#vr-search-placeholder');
        const qtyTextDisplay = this.el.querySelector('#vr-qty-text-display');
        const priceTextDisplay = this.el.querySelector('#vr-price-text-display');

        const suggestionsEl = this.el.querySelector('#vr-watchlist-suggestions');
        const statusText = this.el.querySelector('#vr-add-unit-status');
        const apiURL = 'https://api.palosverdestech.com/';

        if (searchInput) {
            this.isSelecting = false;
            
            searchInput.addEventListener('input', async (e) => {
                const val = e.target.value;
                searchTextDisplay.setAttribute('value', val);
                searchPlaceholder.setAttribute('visible', val.length === 0);

                if (this.isSelecting) return;

                const query = val.trim();
                this.selectedTicker = null;
                this.selectedCompany = null;
                
                if (query.length < 1) {
                    statusText.setAttribute('value', '');
                    suggestionsEl.setAttribute('visible', false);
                    return;
                }

                statusText.setAttribute('value', 'Searching...');
                statusText.setAttribute('color', '#AAA');

                try {
                    const response = await fetch(`${apiURL}/tickers/search/${encodeURIComponent(query)}`);
                    if (response.ok) {
                        const data = await response.json();
                        const results = (data.results || []).slice(0, 3);
                        this.renderSuggestions(results);
                    }
                } catch (err) {
                    console.error('Search error', err);
                }
            });

            searchInput.addEventListener('focus', () => {
                if (this._searchFocusBorder) this._searchFocusBorder.setAttribute('visible', true);
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            });
            searchInput.addEventListener('blur', () => {
                if (this._searchFocusBorder) this._searchFocusBorder.setAttribute('visible', false);
            });
        }

        if (qtyInput) {
            qtyInput.addEventListener('input', (e) => {
                const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                qtyTextDisplay.setAttribute('value', displayVal);
            });

            qtyInput.addEventListener('focus', () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', true);
                if (this._searchFocusBorder) this._searchFocusBorder.setAttribute('visible', false);
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            });
            qtyInput.addEventListener('blur', () => {
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            });
        }

        if (priceInput) {
            priceInput.addEventListener('input', (e) => {
                const displayVal = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.truncateInputDisplay(e.target.value) : e.target.value;
                priceTextDisplay.setAttribute('value', displayVal);
            });

            priceInput.addEventListener('focus', () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', true);
                if (this._searchFocusBorder) this._searchFocusBorder.setAttribute('visible', false);
                if (this._qtyFocusBorder) this._qtyFocusBorder.setAttribute('visible', false);
            });
            priceInput.addEventListener('blur', () => {
                if (this._priceFocusBorder) this._priceFocusBorder.setAttribute('visible', false);
            });
        }
    },

    renderSuggestions: function(results) {
        const suggestionsEl = this.el.querySelector('#vr-watchlist-suggestions');
        const statusText = this.el.querySelector('#vr-add-unit-status');
        const searchInput = document.querySelector('#vr-watchlist-search-input');
        
        suggestionsEl.innerHTML = '';
        if (results.length === 0) {
            suggestionsEl.setAttribute('visible', false);
            return;
        }

        suggestionsEl.setAttribute('visible', true);
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');

        const bgWidth = 0.7;
        const rowHeight = 0.08;
        const totalHeight = rowHeight * results.length + 0.02;
        
        const bg = document.createElement('a-rounded-box');
        bg.setAttribute('width', bgWidth);
        bg.setAttribute('height', totalHeight);
        bg.setAttribute('depth', 0.003);
        bg.setAttribute('color', isLight ? '#E0E0E0' : '#2A2A2A');
        bg.setAttribute('position', `0 ${-totalHeight / 2 + 0.04} 0`);
        bg.setAttribute('radius', 0.01);
        suggestionsEl.appendChild(bg);

        results.forEach((item, i) => {
            const row = document.createElement('a-entity');
            row.setAttribute('position', `0 ${-rowHeight * i} 0.01`);
            
            const rowHitbox = document.createElement('a-plane');
            rowHitbox.setAttribute('width', bgWidth);
            rowHitbox.setAttribute('height', rowHeight - 0.01);
            rowHitbox.setAttribute('opacity', 0);
            rowHitbox.setAttribute('data-raycastable', '');
            row.appendChild(rowHitbox);

            const txt = document.createElement('a-troika-text');
            txt.setAttribute('value', `${item.ticker_symbol} - ${item.company_name}`);
            txt.setAttribute('font-size', 0.03);
            txt.setAttribute('color', isLight ? '#14141C' : '#FFF');
            txt.setAttribute('position', `-0.32 0 0.006`);
            txt.setAttribute('anchor', 'left');
            row.appendChild(txt);

            rowHitbox.addEventListener('click', () => {
                this.isSelecting = true;

                this.selectedTicker = item.ticker_symbol;
                this.selectedCompany = item.company_name;
                searchInput.value = item.ticker_symbol;
                
                searchInput.dispatchEvent(new Event('input'));

                statusText.setAttribute('value', `Selected: ${item.ticker_symbol}`);
                statusText.setAttribute('color', '#3636E3');
                
                suggestionsEl.setAttribute('visible', false);
                suggestionsEl.innerHTML = '';
                
                setTimeout(() => { this.isSelecting = false; }, 100);
            });

            suggestionsEl.appendChild(row);
        });
    },

    handleConfirm: function() {
        if (!this.selectedTicker) return;

        const qtyInput = document.querySelector('#vr-watchlist-qty-input');
        const priceInput = document.querySelector('#vr-watchlist-price-input');
        
        const qty = qtyInput.value.trim() === '' ? 0 : (parseFloat(qtyInput.value) || 0);
        const price = priceInput.value.trim() === '' ? 0 : (parseFloat(priceInput.value) || 0);

        if (window.WatchlistApp.Popup && this.options && this.options.onAdd) {
            this.options.onAdd({
                ticker: this.selectedTicker,
                companyName: this.selectedCompany,
                quantity: qty,
                price: price
            });
            window.WatchlistApp.Popup.closeManual('add-unit-vr-popup');
        }
    }
});
